import { useState, useEffect } from 'react';

const FESTIVAL_DATE = new Date('2027-01-21T00:00:00-05:00'); // EST

export default function Countdown() {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft());

  function getTimeLeft() {
    const now = new Date();
    const diff = FESTIVAL_DATE - now;

    if (diff <= 0) return { months: 0, weeks: 0, days: 0, hours: 0, minutes: 0, seconds: 0, isClose: true, isOver: true };

    const totalSeconds = Math.floor(diff / 1000);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const totalHours = Math.floor(totalMinutes / 60);
    const totalDays = Math.floor(totalHours / 24);

    const isClose = totalDays < 1;

    if (isClose) {
      return {
        months: 0,
        weeks: 0,
        days: 0,
        hours: totalHours,
        minutes: totalMinutes % 60,
        seconds: totalSeconds % 60,
        isClose: true,
        isOver: false,
      };
    }

    const months = Math.floor(totalDays / 30);
    const remainingAfterMonths = totalDays % 30;
    const weeks = Math.floor(remainingAfterMonths / 7);
    const days = remainingAfterMonths % 7;

    return { months, weeks, days, hours: 0, minutes: 0, seconds: 0, isClose: false, isOver: false };
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, timeLeft.isClose ? 1000 : 60000);

    return () => clearInterval(interval);
  });

  if (timeLeft.isOver) return null;

  const blocks = timeLeft.isClose
    ? [
        { value: timeLeft.hours, label: 'Hours' },
        { value: timeLeft.minutes, label: 'Min' },
        { value: timeLeft.seconds, label: 'Sec' },
      ]
    : [
        { value: timeLeft.months, label: 'Months' },
        { value: timeLeft.weeks, label: 'Weeks' },
        { value: timeLeft.days, label: 'Days' },
      ].filter((b) => b.value > 0 || b.label === 'Days');

  return (
    <div className="flex gap-3 justify-center mt-6">
      {blocks.map((block) => (
        <div
          key={block.label}
          className="flex flex-col items-center"
        >
          <div
            className="font-display text-3xl md:text-4xl leading-none gradient-text"
          >
            {String(block.value).padStart(2, '0')}
          </div>
          <div className="font-mono text-[0.55rem] tracking-[0.2em] uppercase text-muted mt-1">
            {block.label}
          </div>
        </div>
      ))}
    </div>
  );
}
